<!-- ORIGINAL
*ngIf="(progress$|async)"
*ngIf="christmasTime && (progress$|async)"
-->
<ng-container *ngIf="(progress$|async)">
  <div class="showbox layout-align-center-center layout-row">
    <div class="lds-dual-ring"></div>
  </div>
</ng-container>
